import useReports from "./hook/useReports";
import TableHeadings from '../../components/Common-components/table-headings'
import useLanguage from "../../hooks/useLanguage";
import { imageBaseUrl } from "../../components/Constant";
import { Spinner } from '../../components/Common-components/spinner';
import { getLocalizedText } from "../../utils";
import TableContainer from "./component/tableContainer";
import { Avatar } from "@mui/material";
import moment from "moment-timezone";
import ReadMoreButton from "../../components/Common-components/ReadMoreLess";
const PaymentReceived = () => {
    const { t, isEngLang } = useLanguage();

    const {
        paymentReceivedTableHead,
        details,
        loader,
        handlePagination,
        totalCount,
        controller,
    } = useReports();
    return (
        <>
            {loader && <Spinner />}
            <TableContainer handlePagination={handlePagination} data={details} totalCount={totalCount} title={`${t("boxTitle.paymentReceived")}`} controller={controller}>
                <table className="table ">
                    <TableHeadings removeTr={true} TableHeadData={paymentReceivedTableHead} />
                    <tbody>
                        {details?.map((cur, index) => (
                            <>

                                <tr className='fw-4 font-12' key={cur?._id} >
                                    <td>{cur?.bookingReferenceNumber ?? '-'}</td>
                                    <td >{moment(cur?.createdAt).format("ll")}</td>
                                    <td><ReadMoreButton text={cur?.remarks} maxLength={50} /></td>
                                    <td>{cur?.paymentType ?? "-"}</td>
                                    <td>{cur?.amount ?? "-"}</td>
                                </tr>
                                <tr className='default_tr_gap'> </tr>
                            </>
                        ))}
                    </tbody>
                </table>
            </TableContainer>
        </>
    )
}

export default PaymentReceived
